import React, { useContext, useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getJournalControlPeriods, getJournalControlGroups, getJournalControlData, getJournalControlCourses, deleteJournalControl } from '../../actions/journalControl'
import { useFormik } from 'formik'
import { getSchoolYearsList } from '../../actions/schoolYears'
import { getCLassesByYear, getCourses } from '../../actions/common'
import { getCurrentTermUtils, getCurrentYearUtils } from '../../utils/classBook'
import { getCurrentPeriod } from '../../actions/periods'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { ClassbookContext } from '../../utils/context'

const initialValues = {
  trmid: 0,
  gid: 0
}

export default function JournalControl({ classbook, formData }) {
  const [filters, setFilters] = useState({ scYear: "", studyPeriod: "", lesson: "", class: "", dropouts: 0 });

  const dispatch = useDispatch()
  const navigate = useNavigate()



  const { list: yearList } = useSelector(state => state.school_years)
  const { periods, groups, data } = useSelector(state => state.journal_control)


  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  const currYear = getCurrentYearUtils(yearList, new Date())

  const { values, handleChange, setValues, setFieldValue } = useFormik({ initialValues })

  useEffect(() => {
    dispatch(getSchoolYearsList())
    dispatch(getCourses())
  }, [])

  useEffect(() => {
    if (classbook) return
    currYear && setValues({ ...values, year: currYear })
  }, [currYear])

  useEffect(() => {
    if (!classbook) return
    setFilters(formData)
  }, [classbook])

  useEffect(() => {
    if (classbook) return
    const { year, trmid, gid } = values
    if (year === 0) {
      dispatch(getJournalControlData({ year, trmid: 0, }))
      dispatch(getJournalControlPeriods({ year: 0 }))
    } else {
      const params = { year }
      year && dispatch(getJournalControlPeriods(params))
    }
  }, [values.year])

  //запрос по настоящему моменту
  useEffect(() => {
    if (periods.length) {
      const trmidList = getCurrentTermUtils(periods, '2025.09.04')
      const trmidNow = trmidList[0] || 0
      const { year } = values
      const params = { year, trmid: trmidNow }
      year && dispatch(getJournalControlGroups(params))
      setFieldValue('trmid', trmidNow)
    } else {
      dispatch(getJournalControlGroups({ year: 0, trmid: 0 }))
      setFieldValue('trmid', 0)
    }
  }, [periods])

  useEffect(() => {
    if (classbook) return
    const { year, trmid } = values
    if (!trmid) return;
    const params = { year, trmid }
    year && dispatch(getJournalControlGroups(params))
    // dispatch(getJournalControlGroups({ year: 13, trmid: 14 }))/// заглушки
  }, [values.trmid])

  useEffect(() => {
    if (!!filters.length) dispatch(getJournalControlData({ year: filters.scYear, trmid: filters.studyPeriod, gid: filters.class, })) //TODO ключи!!??
  }, [filters])

  useEffect(() => {
    if (classbook) return
    const { year, trmid, gid } = values
    if (!trmid || !gid) return;
    const params = { year, trmid, gid }
    // dispatch(getJournalControlData(params))
    // dispatch(getJournalControlData({ year: 13, trmid: 14, gid: 7 }))/// заглушки
  }, [values.gid])



  const goTo = (url) => () => navigate(url)

  const openModal = (data) => () => setSelectedItem(data || {})

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    dispatch(deleteJournalControl(confirmation.id));
    setConfirmation(false);
    closeModal();
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const deleteItemHandler = (data) => (e) => {
    e.stopPropagation()
    setConfirmation({ id: data.jmid, name: data.date })
  }


  const renderLi = (data) => {
    const { date, checktext, xp_f_get_mid_fio, subject, group } = data
    return (
      <tr onClick={openModal(data)}>
        <td>{date}</td>
        <td>{checktext}</td>
        <td>{xp_f_get_mid_fio}</td>
        <td>{subject}</td>
        <td>{group}</td>
        <td><i className={styles.trash} onClick={deleteItemHandler(data)}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.id)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          addMode={!selectedItem.jmid}
          valuesFilters={values}
          filters={filters}
        />
      }
      {!classbook &&
        <>
          <h1>Контроль ведения классного журнала</h1>
          <div className={styles.filtersBlock}>

            <div className={styles.inputsRow}>
              <CustomSelect
                title='Учебный год'
                valuesName="year"
                options={arrayForSelect(yearList, 'name', 'xp_key')}
                value={values.year}
                setFieldValue={setFieldValue}
              // withoutAll
              // width={300}
              />
            </div>
            <div className={styles.inputsRow}>
              <CustomSelect
                title='Учебный период'
                valuesName="trmid"
                options={arrayForSelect(periods, 'title', 'trmid')}
                value={values.trmid}
                setFieldValue={setFieldValue}
                withoutAll
              // width={300}
              />
            </div>
            <div className={styles.inputsRow}>
              <CustomSelect
                title='Класс'
                valuesName="gid"
                options={arrayForSelect(groups, 'name', 'gid')}
                value={values.gid}
                setFieldValue={setFieldValue}
              // withoutAll
              // width={300}
              />
            </div>
          </div>
        </>
      }

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Месяц, число</th>
            <th>Замечания и предложения проверяющих</th>
            <th>Отметка о выполнении</th>
            <th>Предмет</th>
            <th>Класс</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.map(renderLi)}
        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
      <div className={styles.footer}>
        <Button mode='white' onClick={goTo('/journal_control')}>Классный журнал</Button>
        <Button onClick={goTo('/')}>На главную</Button>
      </div>
    </div>
  )
}
